<div class="wait-dialog-container">
    <p class="wait-message">{{ data.message }}</p>
    <mat-spinner diameter="40" color="primary"></mat-spinner>
    <button mat-button color="warn" class="cancel-btn" (click)="cancel()">Cancel</button>
</div>
